import React from 'react';

import { gql } from '@apollo/client';
import { ExpandableTextView, FCWithFragments } from '@modernloop/shared/components';

import { ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment } from 'src/generated/mloop-graphql';

import ActivityLogBase from 'src/entities/ActivityLog/Helpers/ActivityLogBase';
import ActivityLogContent from 'src/entities/ActivityLog/Helpers/ActivityLogContent';

type Fragments = {
  activityLog: ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment;
};

const ActivityLogApplicationCandidatePortalNoteUpdated: FCWithFragments<Fragments> = ({ activityLog }) => {
  // eslint-disable-next-line no-underscore-dangle
  if (!activityLog.details || activityLog.details.__typename !== 'ActivityLogCandidatePortalNoteDetails') {
    throw new Error('ActivityLogCandidatePortalNoteDetails: details is not ActivityLogCandidatePortalNoteDetails');
  }

  return (
    <ActivityLogBase
      activityLog={activityLog}
      actionLabelKey="hiring-dashboard-candidates:candidates.activityLog.updatedCandidatePortalNote"
    >
      <ActivityLogContent
        sx={{ borderRadius: '4px 12px 12px 12px' }}
        content={<ExpandableTextView content={activityLog.details.portalNoteContent || ''} hideGradient />}
      />
    </ActivityLogBase>
  );
};

ActivityLogApplicationCandidatePortalNoteUpdated.fragments = {
  activityLog: gql`
    ${ActivityLogBase.fragments.activityLog}
    fragment ActivityLogApplicationCandidatePortalNoteUpdated_activityLog on ActivityLog {
      id
      details {
        ... on ActivityLogCandidatePortalNoteDetails {
          candidatePortalNoteId
          portalNoteContent: content
          sendToCandidate
        }
      }
      ...ActivityLogBase_activityLog
    }
  `,
};

export default ActivityLogApplicationCandidatePortalNoteUpdated;
